<div class="color">
    <app-page-breadcrumb
        [pageInfo]="{title : 'Send Whatsapp Msg',buttonShowBtn : true,button :{title : '', url :'',icon : 'las la-times', color: 'light'}}"></app-page-breadcrumb>
</div>
<div class="row clearfix mt-4">
    <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
        <div class="body">
            <div class="form-group">
                <div class="row clearfix" style="display: flex;">
                    <app-form-generator #basicForm (keyup)="onChange($event)"
                        [formData]="basicFormData"></app-form-generator>
                </div>
                <hr>
                <div class="col-md-6 col-lg-6 align-end text-end mt-1 " style="max-width: 100%;">
                    <ng-container>
                        <button type="button" [disabled]="loading || !valid" (click)="onSubmit()"
                            class="btn btn-round btn-primary pull-left">
                            <i *ngIf="loading" class="pi pi-spin pi-spinner"
                                style="font-size: 1rem; margin-right: 10px;"></i>
                            {{loading ? 'Sending' : 'Send'}}
                        </button>
                        <button type="button" [disabled]="loading" (click)="close()"
                            class="btn btn-round btn-danger pull-left ml-2">
                            <i *ngIf="loading" class="pi pi-spin pi-spinner"
                                style="font-size: 1rem; margin-right: 10px;"></i>
                            Cancel
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>